@for (option of activeOptionGroup.options; let index = $index; track option.id) {
    <div
        class="option-group"
        [ngClass]="[
            showBottomBorder
                ? 'bottom-border'
                : index < activeOptionGroup.options.length - lastRowOptionsCount
                  ? 'bottom-border'
                  : 'no-bottom-border',
        ]"
        [class.option-hidden]="isOutrightGrid && !showOption(index)">
        @if (hasParticipantImage(index)) {
            <ms-participant-image [participantImage]="optionImages[option.id]" [showFallback]="true" [sportId]="activeEvent.sport.id" />
        }
        <span class="name" [title]="option.name">{{ option.name }}</span>
        <ms-option
            [optionGroup]="activeOptionGroup"
            [option]="option"
            [event]="activeEvent"
            [sourceOfPick]="sourceOfPick"
            [tracking]="getTracking(index)"
            [betDetails]="betDetails" />
    </div>
}
